$(document).ready(function() {
    let forms = $('form');
    function gtmPush(event, formId, additional = {}) {
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                ...additional,
                event: event,
                formName: formId
            });
        }
    }

    function checkGA() {
        if (typeof ga === 'function') {
            gtmSetup();
        } else {
            setTimeout(checkGA, 3000);
        }
    }

    function gtmSetup() {
        if (forms) {
            forms.each(function (position, $form) {
                let freeform = $form.freeform;
                if (freeform) {
                    ga(function () {
                        var tracker = ga.getAll()[0];

                        if (freeform.form.gaclientid !== undefined) {
                            freeform.form.gaclientid.value = tracker.get('clientId');
                        }
                        if (freeform.form.gauserid !== undefined) {
                            freeform.form.gauserid.value = tracker.get('userId');
                        }
                        if (freeform.form.gatrackid !== undefined) {
                            freeform.form.gatrackid.value = tracker.get('trackingId');
                        }
                    });
                }
            });
        }
    }

    function setGtmValues(freeform) {
        if (typeof ga === 'function') {
            ga(function () {
                let tracker = ga.getAll()[0];

                if (freeform.form.gaclientid !== undefined) {
                    freeform.form.gaclientid.value = tracker.get('clientId');
                }
                if (freeform.form.gauserid !== undefined) {
                    freeform.form.gauserid.value = tracker.get('userId');
                }
                if (freeform.form.gatrackid !== undefined) {
                    freeform.form.gatrackid.value = tracker.get('trackingId');
                }
            });
        }
    }

    function setUtmValues(freeform, queryParams) {
        if ('utm_source' in queryParams) {
            Cookies.set('utm_source', queryParams['utm_source'][0], { expires: 1 });
        }
        if ('utm_medium' in queryParams) {
            Cookies.set('utm_medium', queryParams['utm_medium'][0], { expires: 1 });
        }
        if ('utm_campaign' in queryParams) {
            Cookies.set('utm_campaign', queryParams['utm_campaign'][0], { expires: 1 });
        }
        if ('utm_content' in queryParams) {
            Cookies.set('utm_content', queryParams['utm_content'][0], { expires: 1 });
        }

        if (freeform.form.utmSource !== undefined && Cookies.get('utm_source')) {
            freeform.form.utmSource.value = Cookies.get('utm_source');
        }

        if (freeform.form.utmMedium !== undefined && Cookies.get('utm_medium')) {
            freeform.form.utmMedium.value = Cookies.get('utm_medium');
        }

        if (freeform.form.utmCampaign !== undefined && Cookies.get('utm_campaign')) {
            freeform.form.utmCampaign.value = Cookies.get('utm_campaign');
        }

        if (freeform.form.utmContent !== undefined && Cookies.get('utm_content')) {
            freeform.form.utmContent.value = Cookies.get('utm_content');
        }
    }

    function setFavouritedElevations(freeform) {
        if (freeform.form.favouritedElevations && Cookies.get('favourite_elevations')) {
            freeform.form.favouritedElevations.value = Cookies.get('favourite_elevations');
        }
    }

    function pageDetails(freeform) {
        if (freeform.form.pageUrl) {
            freeform.form.pageUrl.value = window.location.href;
        }
        if (freeform.form.pageTitle && freeform.form.dataset.pageTitle) {
            freeform.form.pageTitle.value = freeform.form.dataset.pageTitle
        }
    }

    function resetForm() {
        $('.freeform-column').each(function () {
            if ($(this)[0].hasAttribute('data-ff-rule')) {
                $(this).css('display', 'none');
            }
        });
    }

    function fadeOutNotifications() {
        setTimeout(function() {
            $('.ff-form-errors, .ff-form-success').fadeOut();
        }, 5000);
        setTimeout(function() {
            $('.ff-errors').fadeOut();
        }, 15000);
    }

    function getUrlQueryParams() {
        var queryString = window.location.search || '';
        var keyValPairs = [];
        var params = {};
        queryString = queryString.substr(1);

        if (queryString.length) {
            keyValPairs = queryString.split('&');
            for (let pairNum in keyValPairs) {
                var key = keyValPairs[pairNum].split('=')[0];
                if (!key.length) {
                    continue;
                }
                if (typeof params[key] === 'undefined') {
                    params[key] = [];
                }
                params[key].push(keyValPairs[pairNum].split('=')[1]);
            }
        }

        return params;
    }

    //Customise freeform functions
    if (forms) {
        forms.each(function (position, $form) {
            let freeform = $form.freeform;

            if (freeform) {
                // push form id to data layer
                const formId = freeform.form.id;
                let isBackButtonPressed = null;
                let finalStepOfMultistep = false;
                let favourites = 'false';
                let contactType = null;

                //Override Freeforms default error message
                freeform.setOption('errorBannerMessage', 'Error! Please check required fields and try again.');
                freeform.setOption('successBannerMessage', 'Thanks! Submission successful.');

                this.addEventListener("freeform-on-submit", function (event) {
                    // If Elevations are in cookies save to form
                    setFavouritedElevations(freeform);
                    // Save page details to form values
                    pageDetails(freeform);
                    // If UTM Queries exist, define their values
                    setUtmValues(freeform, getUrlQueryParams());
                    setGtmValues(freeform)

                    isBackButtonPressed = event.isBackButtonPressed;
                });

                //show original message on successful submit
                freeform.addOnAfterAjaxSubmit((event, form, response) => {
                    $('.ff-form-errors, .ff-form-success').insertAfter(
                        $('#' + formId + ' button').closest('.freeform-row')
                    );
                    fadeOutNotifications();

                    let submitButton = event.target.querySelector('button[name="form_page_submit"]');
                    if (submitButton) {
                        submitButton.addEventListener('click', event => {
                            let formContactMethod = event.target.closest('form').querySelector('div[data-contactmethod]');
                            let emailInput = event.target.closest('form').querySelector('input[name="email"]');
                            let phoneInput = event.target.closest('form').querySelector('input[name="phone"]');

                            if (formContactMethod) {
                                if (formContactMethod.dataset.contactmethod === 'Call' || formContactMethod.dataset.contactmethod === 'SMS') {
                                    phoneInput.closest('div').querySelector('label').classList.add('required-input-form-field');
                                    phoneInput.setAttribute('required', 'true');
                                    emailInput.closest('div').querySelector('label').classList.remove('required-input-form-field');
                                    emailInput.removeAttribute('required');
                                } else {
                                    emailInput.closest('div').querySelector('label').classList.add('required-input-form-field');
                                    emailInput.setAttribute('required', 'true');
                                    phoneInput.closest('div').querySelector('label').classList.remove('required-input-form-field');
                                    phoneInput.removeAttribute('required');
                                }
                            }
                        })
                    }
                });

                $form.addEventListener('freeform-ajax-before-submit', function(event) {
                    const payload = event.data;

                    if (!$form.checkValidity()) {
                        event.preventDefault();
                        return false;
                    }

                    if (payload.get('favouritedElevations')) {
                        favourites = 'true';
                    }

                    if (payload.get('preferredContactMethod') !== null) {
                        contactType = payload.get('preferredContactMethod');
                    } else if (payload.get('contactMethod') !== null) {
                        contactType = payload.get('contactMethod');
                    }

                    $form.dataLayerSubmission = {
                        gaFormName: payload.get('GAFORMNAME'),
                        gaContactType: contactType,
                        gaFavourites:  favourites,
                    };

                    if (formId.toLowerCase().indexOf('multipage') !== -1) {
                        finalStepOfMultistep = !!event.target.querySelector('input[name="GAFORMNAME"]');
                    }
                });

                freeform.addOnSuccessfulAjaxSubmit(function (event, form, response) {
                    if (formId.toLowerCase().indexOf('multipage') === -1) {
                        resetForm();
                        gtmPush('formSubmitted', formId, {enquiryFormData: $form.dataLayerSubmission});
                    } else if (!isBackButtonPressed && finalStepOfMultistep) {
                        resetForm();
                        gtmPush('formSubmitted', formId, {enquiryFormData: $form.dataLayerSubmission});
                    }

                    if (formId === 'contactForm' || formId === 'modalContactForm') {
                        let formContainerScrollAnchor = $form.closest('.form-panel').querySelector('.form-scroll-anchor');
                        $form.closest('.form-container').style.height = 'auto';
                        if (window.matchMedia('(max-width: 1024px)').matches && formContainerScrollAnchor) {
                            formContainerScrollAnchor.scrollIntoView({
                                behavior: 'smooth',
                                alignToTop: true
                            })
                        }
                    }

                    if (formId.toLowerCase().indexOf('multipage') !== -1) {
                        let formContactMethod = event.target.querySelector('div[data-contactmethod]');
                        let emailInput = event.target.querySelector('input[name="email"]');
                        let phoneInput = event.target.querySelector('input[name="phone"]');
                        let fNameInput = event.target.querySelector('input[name="firstName"]');
                        let lNameInput = event.target.querySelector('input[name="lastName"]');
                        let pPolicies = event.target.querySelectorAll('input[name="privacyPolicyAccepted"]');
                        let backButton = event.target.querySelector('button[name="form_previous_page_button"]')

                        if (formContactMethod) {
                            fNameInput.setAttribute('required', 'true');
                            lNameInput.setAttribute('required', 'true');
                            for (let pPolicy of pPolicies) {
                                pPolicy.setAttribute('required', 'true');
                            }

                            if (formContactMethod.dataset.contactmethod === 'Call' || formContactMethod.dataset.contactmethod === 'SMS') {
                                phoneInput.closest('div').querySelector('label').classList.add('required-input-form-field');
                                phoneInput.setAttribute('required', 'true');
                                emailInput.closest('div').querySelector('label').classList.remove('required-input-form-field');
                                emailInput.removeAttribute('required');
                            } else {
                                emailInput.closest('div').querySelector('label').classList.add('required-input-form-field');
                                emailInput.setAttribute('required', 'true');
                                phoneInput.closest('div').querySelector('label').classList.remove('required-input-form-field');
                                phoneInput.removeAttribute('required');
                            }
                            if (backButton) {
                                backButton.addEventListener('click', event => {
                                    emailInput.closest('div').querySelector('label').classList.remove('required-input-form-field');
                                    phoneInput.closest('div').querySelector('label').classList.remove('required-input-form-field');
                                    emailInput.removeAttribute('required');
                                    phoneInput.removeAttribute('required');
                                    fNameInput.removeAttribute('required');
                                    lNameInput.removeAttribute('required');
                                    for (let pPolicy of pPolicies) {
                                        pPolicy.removeAttribute('required');
                                    }
                                })
                            }
                        }
                    }
                });
            }
        });
    }

    checkGA();
});
